import { useEffect, useState } from "react";

import { createInstance, MatomoProvider } from "@jonkoops/matomo-tracker-react";
import * as VanillaCookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./cookieconcent.css";

let instance = null;
if (process.env.REACT_APP_MATOMO_URL_BASE) {
  instance = createInstance({
    urlBase: process.env.REACT_APP_MATOMO_URL_BASE,
    siteId: process.env?.REACT_APP_MATOMO_SITE_ID ?? 1,
    userId: process.env?.REACT_APP_MATOMO_USER_ID ?? undefined,
    configurations: {
      // optional, default value: {}
      // any valid matomo configuration, all below are optional
      disableCookies: true,
      setSecureCookie: true,
      setRequestMethod: "POST",
    },
  });
}

export const CookieConsent = ({ children }) => {
  const [analyticsAccepted, setAnalyticsAccepted] = useState(false);

  useEffect(() => {
    VanillaCookieConsent.run({
      root: "#root",
      onConsent(c) {
        if (VanillaCookieConsent.acceptedCategory("analytics")) {
          console.log("Analytics cookies accepted");
          setAnalyticsAccepted(true);
        } else {
          console.log("Analytics cookies not accepted");
          setAnalyticsAccepted(false);
        }
      },
      onChange(c) {
        if (VanillaCookieConsent.acceptedCategory("analytics")) {
          console.log("onChange:Analytics cookies accepted");
          setAnalyticsAccepted(true);
        } else {
          console.log("onChange:Analytics cookies not accepted");
          setAnalyticsAccepted(false);
        }
      },
      language: {
        default: "no",
        translations: {
          no: {
            consentModal: {
              title: "Velg hvilke informasjonskapsler vi får bruke",
              description:
                "Nødvendige informasjonskapsler sørger for at nettstedet fungerer som det skal. Andre informasjonskapsler hjelper oss med å forbedre nettstedet. Godkjenner du alle, hjelper du oss å lage et bedre nettsted. <a href='/personvern'>Mer informasjon om våre informasjonskapsler</a>",
              acceptAllBtn: "Godkjenn alle",
              acceptNecessaryBtn: "Bare nødvendige",
              // showPreferencesBtn: "Administrer individuelle preferanser",
            },
          },
        },
      },
      mode: "opt-in",
      categories: {
        necessary: {
          enabled: true, // this category is enabled by default
          readOnly: true, // this category cannot be disabled
        },
        analytics: {},
      },
    });
  }, []);

  if (instance && analyticsAccepted) {
    return <MatomoProvider value={instance}>{children}</MatomoProvider>;
  }

  return children;
};
